<div class="partner-area ptb-100">
    <div class="container">
        <div class="section-title">
            <h2>Our Partners</h2>
        </div>
        
        <div class="partner-slides owl-carousel owl-theme">
            <div class="partner-item">
                <a href="#"><img src="assets/img/partner1.png" alt="image"></a>
            </div>

            <div class="partner-item">
                <a href="#"><img src="assets/img/partner2.png" alt="image"></a>
            </div>

            <div class="partner-item">
                <a href="#"><img src="assets/img/partner3.png" alt="image"></a>
            </div>

            <div class="partner-item">
                <a href="#"><img src="assets/img/partner4.png" alt="image"></a>
            </div>

            <div class="partner-item">
                <a href="#"><img src="assets/img/partner7.png" alt="image"></a>
            </div>

            <div class="partner-item">
                <a href="#"><img src="assets/img/partner7.png" alt="image"></a>
            </div>
        </div>
    </div>
</div>